import { render, staticRenderFns } from "./GerenciadorCotacoes.vue?vue&type=template&id=3480e4c7&scoped=true"
import script from "./GerenciadorCotacoes.vue?vue&type=script&lang=js"
export * from "./GerenciadorCotacoes.vue?vue&type=script&lang=js"
import style0 from "./GerenciadorCotacoes.vue?vue&type=style&index=0&id=3480e4c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480e4c7",
  null
  
)

export default component.exports